import CarouselSection from "./components/CarouselSection";
import BenefitsSection from "./components/BenefitsSection";
import HeroSection from "./components/HeroSection";
import WhatWeProposeSection from "./components/WhatWeProposeSection";
import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import { Container } from "@mui/material";

const WhyTrackmate = () => {
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, md: 2 } }}>
        <BreadcrumbsNav />
      </Container>
      <HeroSection />
      <CarouselSection />
      <BenefitsSection />
      <WhatWeProposeSection />
    </>
  );
};

export default WhyTrackmate;
